import React from "react"
import ReactDOM from "react-dom"
import { graphql } from "gatsby"

import SEO from "../components/helpers/seo"
import TextCentered from "../components/helpers/TextCentered"
import Button from "../components/atoms/Button"
import Image from "../components/atoms/Image"
import Grid from "../components/organisms/Grid"
import Layout from "../components/templates/Layout"

import RsvpView from "../components/views/RsvpView"
import InstructionsView from "../components/views/InstructionsView"

class IndexPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showRSVP: false,
      attendees: this.props.data.allGuestListCsv.edges,
      primaryImage: this.props.data.primaryImageSmall.childImageSharp.fluid,
    }

    this.showRsvpForm = this.showRsvpForm.bind(this)
    this.hideRsvpForm = this.hideRsvpForm.bind(this)

    this.modalPortal = null
  }

  showRsvpForm() {
    this.setState({
      showRSVP: true,
    })
  }

  hideRsvpForm() {
    this.setState({
      showRSVP: false,
    })
  }

  componentDidMount() {
    this.modalPortal = document.createElement("div")
    document.querySelector("body").appendChild(this.modalPortal)
    this.updatePrimaryImage()
    this.forceUpdate() // Dangerous, but doing so that the animation is smooth
  }

  componentWillUnmount() {
    document.querySelector("body").removeChild(this.modalPortal)
  }

  updatePrimaryImage() {
    if (window.matchMedia("(min-width: 700px)").matches) {
      this.setState({
        primaryImage: this.props.data.primaryImageLarge.childImageSharp.fluid,
      })
    }
  }

  renderModal() {
    if (this.modalPortal) {
      return ReactDOM.createPortal(
        <RsvpView
          show={this.state.showRSVP}
          handleClose={this.hideRsvpForm}
          attendees={this.state.attendees}
        />,
        this.modalPortal
      )
    }
  }

  getBrowserWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    )
  }

  render() {
    return (
      <Layout scrollLocked={this.state.showRSVP}>
        <SEO title="Home" />
        <Grid type="rows">
          <TextCentered>
            <Image
              fluid={this.state.primaryImage}
              alt="Lashan and Zeke smiling"
              full={true}
            />
            <p>
              joyfully request your presence as we exchange vows for the bonds
              of marriage
            </p>
            <p>
              <Button onClick={this.showRsvpForm}>RSVP</Button>
            </p>
          </TextCentered>

          <InstructionsView />
        </Grid>
        {this.modalPortal && this.renderModal()}
      </Layout>
    )
  }
}

export const query = graphql`
  query {
    allGuestListCsv(sort: { fields: First_Name, order: ASC }) {
      edges {
        node {
          id
          First_Name
          Last_name
          Number_Invited_Guests___Wedding
        }
      }
    }
    primaryImageSmall: file(
      relativePath: { eq: "intro-graphic-small-screen@2x-80.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 1600, quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    primaryImageLarge: file(
      relativePath: { eq: "intro-graphic-large-screen@2x-80.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 3000, quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default IndexPage
